export default {
  currency: {
    style: 'decimal',
    currency: 'USD',
    minimumFractionDigits: 2,
  },
};



// WEBPACK FOOTER //
// ./src/app/numberFormats/en/index.js